import { Component, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrl: "../assets/css/error.css"
})
export class PageNotFoundComponent {
  constructor(private renderer: Renderer2) { }
  contactType: string = localStorage.getItem('contactType');

  ngOnInit() {
  }
}
